/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGAProfileHeaderQueryVariables = {|
  playerId: string
|};
export type PGAProfileHeaderQueryResponse = {|
  +playerInfo: ?{|
    +name: string,
    +sport: ?{|
      +name: string
    |},
    +playerDkId: number,
    +headshotUrl: ?string,
  |}
|};
export type PGAProfileHeaderQuery = {|
  variables: PGAProfileHeaderQueryVariables,
  response: PGAProfileHeaderQueryResponse,
|};
*/


/*
query PGAProfileHeaderQuery(
  $playerId: ID!
) {
  playerInfo(playerId: $playerId) {
    name
    sport {
      name
      id
    }
    playerDkId
    headshotUrl
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "playerId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "playerId",
    "variableName": "playerId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "playerDkId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headshotUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAProfileHeaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PlayerType",
        "kind": "LinkedField",
        "name": "playerInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SportType",
            "kind": "LinkedField",
            "name": "sport",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAProfileHeaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PlayerType",
        "kind": "LinkedField",
        "name": "playerInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SportType",
            "kind": "LinkedField",
            "name": "sport",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a55460343ab978a430e8f3b109e74caa",
    "id": null,
    "metadata": {},
    "name": "PGAProfileHeaderQuery",
    "operationKind": "query",
    "text": "query PGAProfileHeaderQuery(\n  $playerId: ID!\n) {\n  playerInfo(playerId: $playerId) {\n    name\n    sport {\n      name\n      id\n    }\n    playerDkId\n    headshotUrl\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd4bb19d02ac822e80a21c37669e79fd9';

module.exports = node;
